import DownloadDataScreen from './DownloadDataScreen';

export default DownloadDataScreen;
